module.exports = __webpack_public_path__ + "img/map.ebfd86a9.png";